import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { DataLakeConfig as DataLakeConfigApi } from "@graylog/enterprise-api";
import { DATA_LAKE_CONFIG_QUERY_KEYS } from "data-lake/Constants";
const fetchDataLakeConfig = () => DataLakeConfigApi.get();
const useDataLakeConfig = (enabled = true) => {
  const { data, refetch, isInitialLoading, isSuccess, error } = useQuery({
    queryKey: [...DATA_LAKE_CONFIG_QUERY_KEYS],
    queryFn: () => fetchDataLakeConfig(),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data,
    refetch,
    isInitialLoading,
    isSuccess,
    error
  };
};
export default useDataLakeConfig;
